// =========================================================
// * Inception Admin
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * Official Repository: https://github.com/themesberg/volt-react-dashboard
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { HashRouter } from "react-router-dom";

// core styles
import "./scss/volt.scss";
// vendor styles
import "react-datetime/css/react-datetime.css";

import HomePage from "./pages/HomePage";
import ScrollToTop from "./components/ScrollToTop";
import { PermissionProvider } from "./context/PermissionContext";
import { ArchiveProvider } from "./context/ArchiveContext";
import { SidebarProvider } from "./context/SidebarContext";
import { AuthProvider } from "./context/AuthContext";
import { ExportProvider } from "./context/ExportContext";
import { ExportManager } from "./helper/ExportFile/ExportBar";
import { UploadProvider } from "./context/UploadContext";
import { UploadBar } from "./helper/UploadFile/UploadBar";
import AppErrorBoundary from "./components/AppErrorBoundary";

ReactDOM.render(
  <AppErrorBoundary>
    <HashRouter>
      <AuthProvider>
        <UploadProvider>
          <UploadBar />
          <ExportProvider>
            <ExportManager />
            <ScrollToTop />
            <PermissionProvider>
              <ArchiveProvider>
                <SidebarProvider>
                  <HomePage />
                </SidebarProvider>
              </ArchiveProvider>
            </PermissionProvider>
          </ExportProvider>
        </UploadProvider>
      </AuthProvider>
    </HashRouter>
  </AppErrorBoundary>,
  document.getElementById("root")
);
